module.exports = __webpack_public_path__ + "img/filter_01_icon.5ae73198.svg";